// Get the user's allowed routes from local storage.
export function getStoredAllowedRoutes() {
  try {
    const routes = JSON.parse(
      localStorage.getItem("allowedRoutes") || "[]"
    );

    return Array.isArray(routes) ? routes : [];
  } catch (error) {
    return [];
  }
}

// Decide the landing page using the actual permitted routes.
export function getLandingRoute(allowedRoutes = []) {
  if (!Array.isArray(allowedRoutes)) {
    return "/home";
  }

  const hasDashboardAccess = allowedRoutes.some((route) => {
    const normalizedPath = String(route ?? "")
      .trim()
      .replace(/^\/+|\/+$/g, "")
      .toLowerCase();

    return normalizedPath === "dashboard";
  });

  return hasDashboardAccess ? "/dashboard" : "/home";
}